export const initialFiltersState = {
  filters: [],
  activeFilters: [],
  fixedFilters: [],
  filterSelection: null,
  filterSelectionOperators: [],
  filterSelectionOptions: [],
  onAddActiveFilter: (filter, activeFilters) => ({ filter, activeFilters }),
  onRemoveActiveFilter: (filter, activeFilters) => ({ filter, activeFilters }),
  onUpdateActiveFilter: (filter, activeFilters) => ({ filter, activeFilters }),
  onClearActiveFilters: () => true,
  loadFilterOptions: filter => filter.filterOptions || [],
};

export default (state, action) => {
  switch (action.type) {
    case 'FILTERS_INITIALIZE':
      return {
        ...state,
        ...action.state,
      };
    case 'FILTERS_SET_FILTERS':
      return {
        ...state,
        filters: action.filters,
      };
    case 'FILTERS_SET_ACTIVE_FILTERS':
      return {
        ...state,
        activeFilters: action.activeFilters,
      };
    case 'FILTERS_SET_FIXED_FILTERS':
      return {
        ...state,
        fixedFilters: action.fixedFilters,
      };
    case 'FILTERS_SET_FILTER_SELECTION':
      return {
        ...state,
        filterSelection: action.filterSelection,
      };
    case 'FILTERS_SET_LOAD_FILTER_OPTIONS':
      return {
        ...state,
        loadFilterOptions: action.loadFilterOptions,
      };
    default:
      return { ...state };
  }
};
